var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGsmBars = function SvgGsmBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0a4 4 0 0 1 4 4v24a4 4 0 0 1-8 0V4a4 4 0 0 1 4-4zM16 8a4 4 0 0 1 4 4v16a4 4 0 0 1-8 0V12a4 4 0 0 1 4-4zM4 20a4 4 0 0 1 4 4v4a4 4 0 0 1-8 0v-4a4 4 0 0 1 4-4z"
  })));
};

export default SvgGsmBars;